import cronstrue from 'cronstrue';

/**
 * Converts a cron expression to a human-readable description.
 * Returns an empty string for falsy input and 'Invalid cron expression' for unparseable expressions.
 * @param {string} cron - A cron expression (e.g. "0 2 * * *").
 * @returns {string} Human-readable description, or '' / 'Invalid cron expression'.
 */
export const cronDescription = cron => {
  if (!cron) return '';
  try {
    return cronstrue.toString(cron, { use24HourTimeFormat: true });
  } catch (_) {
    return 'Invalid cron expression';
  }
};
